import { render } from "./Dialog.vue?vue&type=template&id=3879e6bf&scoped=true&ts=true"
import script from "./Dialog.vue?vue&type=script&lang=ts"
export * from "./Dialog.vue?vue&type=script&lang=ts"

import "./Dialog.vue?vue&type=style&index=0&id=3879e6bf&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3879e6bf"]])

export default __exports__